// Sentry initialisation. Called once from main.ts.
// No-ops when the DSN is empty (dev/CI) so feature code can keep using the
// SentryService surface without env-guards everywhere.

import * as Sentry from '@sentry/vue'
import type { App } from 'vue'
import type { Router } from 'vue-router'
import { config, flags } from '@core/config'
import { getSessionId, sentryTransport, registerTransport } from '@core/logging'

export const initSentry = (app: App, router: Router): void => {
  if (!flags.sentryEnabled) return

  Sentry.init({
    app,
    dsn: config.sentry.dsn,
    environment: config.sentry.environment,
    release: config.sentry.release || `${config.app.name}@${config.app.version}`,
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: config.sentry.tracesSampleRate,
    // Keep trace headers local — cross-origin admin API CORS doesn't allow
    // Sentry's distributed tracing headers (sentry-trace, baggage).
    tracePropagationTargets: ['localhost'],
  })

  Sentry.setTag('session_id', getSessionId())
  Sentry.setTag('service.name', config.app.name)
  Sentry.setTag('service.version', config.app.version)

  // Wire the Sentry transport into the logger now that Sentry is init'd.
  registerTransport(sentryTransport)
}
